import Vue from 'vue';
import './translate.filter';
import dictionaryPlugin from '@/core/translation/dictionary.plugin';

Vue.use(dictionaryPlugin);
